import { render, staticRenderFns } from "./ChromeAlert.vue?vue&type=template&id=4bba04c2&"
import script from "./ChromeAlert.vue?vue&type=script&lang=js&"
export * from "./ChromeAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports